<div class="web-theme-customizer">
  <div class="row">
    <div class="col-sm-12">
      <div class="element-wrapper">
        <div class="element-box">
          <h5 class="form-header">{{ 'reservationTheme.integration.title' | translate }}</h5>
          <div class="form-desc">
            {{ 'reservationTheme.integration.description' | translate }}
          </div>

          <mat-accordion class="integration-expandable">
            <mat-expansion-panel>
              <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'">
                <i class="icon icon-code"></i>
                <div>
                  <mat-panel-title>{{ 'reservationTheme.integration.directLink.title' | translate }}</mat-panel-title>
                  <mat-panel-description>
                    {{ 'reservationTheme.integration.directLink.description' | translate }}
                  </mat-panel-description>
                </div>
              </mat-expansion-panel-header>
              <div>
                <code>
                  https://alpha.reservation.gastro.digital/reservation/{{ activeClientId }}
                  <a
                    class="btn btn-light"
                    style="padding: 0"
                    href="https://alpha.reservation.gastro.digital/reservation/{{ activeClientId }}"
                    target="_blank"
                  >
                    <mat-icon style="font-size: 18px; line-height: 22px;">launch</mat-icon>
                  </a>
                </code>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'">
                <i class="icon icon-code"></i>
                <div>
                  <mat-panel-title>{{ 'reservationTheme.integration.widget.title' | translate }}</mat-panel-title>
                  <mat-panel-description>
                    {{ 'reservationTheme.integration.widget.description' | translate }}
                  </mat-panel-description>
                </div>
              </mat-expansion-panel-header>
              <div>
                {{ 'reservationTheme.integration.widget.step1' | translate }}
                <code> &#x3C;script src=&#x22;{{ widgetScriptUrl }}&#x22;&#x3E;&#x3C;/script&#x3E; </code>
                <br />
                {{ 'reservationTheme.integration.widget.step2' | translate }}
                <code>
                  &#x3C;reservation-widget<br />
                  &nbsp;&nbsp;client-id=&#x22;{{ activeClientId }}&#x22;<br />
                  &nbsp;&nbsp;asset-base=&#x22;{{ widgetAssetBase }}&#x22;&#x3E;<br />
                  &#x3C;/reservation-widget&#x3E;
                </code>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 col-md-6">
      <div class="element-wrapper">
        <div class="element-box">
          <h5 class="form-header">{{ 'reservationTheme.presets.title' | translate }}</h5>
          <div class="form-desc">
            {{ 'reservationTheme.presets.description' | translate }}
          </div>
          <div class="theme-presets">
            <div class="presets-row">
              <button
                *ngFor="let name of presetNames"
                type="button"
                class="preset-btn"
                [class.active]="selectedPreset === name"
                [style.background-color]="selectedPreset === name ? activePrimaryHex : null"
                (click)="applyPreset(name)"
              >
                {{ name }}
              </button>
            </div>
          </div>

          <h5 class="form-header section-sep">{{ 'reservationTheme.colors.title' | translate }}</h5>
          <div class="token-groups">
            <div class="token-group" *ngFor="let group of tokenGroups; trackBy: trackByGroup">
              <button type="button" class="group-header" (click)="toggleGroup(group)">
                <span>{{ group.name | translate }}</span>
                <mat-icon>{{ group.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>

              <div class="group-tokens" *ngIf="group.expanded">
                <div class="token-row" *ngFor="let row of group.rows; trackBy: trackByKey">
                  <label class="token-label" [title]="row.key">{{ row.label | translate }}</label>
                  <input
                    type="color"
                    class="color-input"
                    [value]="row.hex"
                    (change)="onColorChange(row, $event.target['value'])"
                  />
                  <span class="hex-value">{{ row.hex }}</span>
                </div>
              </div>
            </div>
          </div>

          <h5 class="form-header section-sep">{{ 'reservationTheme.fonts.title' | translate }}</h5>

          <h5 class="form-header font-sub-header">{{ 'reservationTheme.fonts.primaryTitle' | translate }}</h5>
          <div class="font-wrapper">
            <div
              class="font"
              [(fontPicker)]="primaryFontObj"
              [fpWidth]="'320px'"
              [fpDialogDisplay]="'popup'"
              [fpSizeSelect]="true"
              [fpSearchText]="'reservationTheme.fonts.search' | translate"
              [fpLoadingText]="'reservationTheme.fonts.loading' | translate"
              [fpPopularLabel]="'reservationTheme.fonts.popular' | translate"
              [fpResultsLabel]="'reservationTheme.fonts.results' | translate"
              [fpStyleSelect]="false"
              [style.font-family]="primaryFont"
              (fontPickerChange)="changePrimaryFont($event)"
            >
              {{ primaryFont }}
            </div>
            <div class="form-desc">{{ 'reservationTheme.fonts.primaryDesc' | translate }}</div>
            <div class="font-preview-block" [style.font-family]="primaryFont">
              <h3>{{ 'reservationTheme.fonts.primaryPreviewHeading' | translate }}</h3>
              <h5>{{ 'reservationTheme.fonts.primaryPreviewSubheading' | translate }}</h5>
            </div>
          </div>

          <h5 class="form-header font-sub-header">{{ 'reservationTheme.fonts.secondaryTitle' | translate }}</h5>
          <div class="font-wrapper">
            <div
              class="font"
              [(fontPicker)]="secondaryFontObj"
              [fpWidth]="'320px'"
              [fpDialogDisplay]="'popup'"
              [fpSizeSelect]="true"
              [fpSearchText]="'reservationTheme.fonts.search' | translate"
              [fpLoadingText]="'reservationTheme.fonts.loading' | translate"
              [fpPopularLabel]="'reservationTheme.fonts.popular' | translate"
              [fpResultsLabel]="'reservationTheme.fonts.results' | translate"
              [fpStyleSelect]="false"
              [style.font-family]="secondaryFont"
              (fontPickerChange)="changeSecondaryFont($event)"
              #secondaryFontPickerRef
            >
              {{ secondaryFont }}
            </div>
            <div class="form-desc">{{ 'reservationTheme.fonts.secondaryDesc' | translate }}</div>
            <div class="font-preview-block" [style.font-family]="secondaryFont">
              <p>{{ 'reservationTheme.fonts.secondaryPreviewText' | translate }}</p>
              <p class="text-muted small">{{ 'reservationTheme.fonts.secondaryPreviewSmall' | translate }}</p>
            </div>
          </div>

          <div class="theme-actions">
            <button type="button" class="btn btn-outline-secondary btn-md" (click)="reset()">
              <mat-icon>refresh</mat-icon>
              {{ 'reservationTheme.actions.reset' | translate }}
            </button>
            <button type="button" class="btn btn-primary btn-md" [disabled]="isSaving" (click)="save()">
              <mat-icon>save</mat-icon>
              {{
                isSaving
                  ? ('reservationTheme.actions.saving' | translate)
                  : ('reservationTheme.actions.save' | translate)
              }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-6" style="display: flex;">
      <div class="preview-view" #widgetPreview>
        <reservation-widget
          *axLazyElement="widgetScriptUrl"
          [attr.client-id]="activeClientId"
          [attr.asset-base]="widgetAssetBase"
          theme-from-host
        ></reservation-widget>
      </div>
    </div>
  </div>
</div>
